import { format } from "date-fns";
import { LeadsPropriosInterface } from "interfaces/wallet.interface";
import { resolveHierarchyFilters } from "./resolveHierarchyFilters";

const formatDate = (dateStr: string | null | undefined): string | null => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return format(date, "yyyy-MM-dd");
};

const addField = (body: Record<string, any>, key: string, value: any): void => {
  if (value !== null && value !== undefined && value !== "") {
    body[key] = value;
  }
};

const extractValues = (items: any[] | undefined): string[] | undefined => {
  if (!items || items.length === 0) return undefined;
  return items.map((item: any) => item?.value ?? item);
};

export function buildFiltersBody(
  filters: LeadsPropriosInterface
): Record<string, any> {
  const body: Record<string, any> = {};

  // Datas
  addField(
    body,
    "InicioIntervaloCadastroLead",
    formatDate(filters.InicioIntervaloCadastroLead)
  );
  addField(
    body,
    "FimIntervaloCadastroLead",
    formatDate(filters.FimIntervaloCadastroLead)
  );
  addField(
    body,
    "InicioIntervaloAtualizacaoLead",
    formatDate(filters.InicioIntervaloAtualizacaoLead)
  );
  addField(
    body,
    "FimIntervaloAtualizacaoLead",
    formatDate(filters.FimIntervaloAtualizacaoLead)
  );
  addField(
    body,
    "InicioIntervaloTransferencia",
    formatDate(filters.InicioIntervaloTransferencia)
  );
  addField(
    body,
    "FimIntervaloTransferencia",
    formatDate(filters.FimIntervaloTransferencia)
  );

  // Booleanos
  addField(
    body,
    "FiltrarRecebidosPorTransferencia",
    filters.FiltrarRecebidosPorTransferencia
  );
  addField(
    body,
    "SemEmpreendimentoInteresse",
    filters.SemEmpreendimentoInteresse
  );
  addField(body, "LeadsDesqualificados", filters.LeadsDesqualificados);

  // Condicionais (string → boolean)
  if (filters.OrdenarPorRecentes) {
    body.OrdenarPorRecentes = filters.OrdenarPorRecentes === "recentes";
  }
  if (filters.IdentificaCliente) {
    body.IdentificaCliente = filters.IdentificaCliente === "sim";
  }
  if (filters.Visitou) {
    body.Visitou = filters.Visitou === "sim";
  }

  // Arrays diretos
  addField(body, "Status", filters.Status);
  addField(body, "IdsTemperaturasLead", filters.IdsTemperaturasLead);
  addField(body, "QuantidadesDormitorios", filters.QuantidadesDormitorios);
  addField(body, "IdsZonasEmpreendimentos", filters.IdsZonasEmpreendimentos);
  addField(body, "IdsTipoEmpreendimentos", filters.IdsTipoEmpreendimentos);
  addField(body, "IdsObjetivosCompra", filters.IdsObjetivosCompra);
  addField(body, "IdsPrazosEntrega", filters.IdsPrazosEntrega);
  addField(body, "Etapas", filters.Etapas);
  addField(body, "IdsEtiquetas", filters.IdsEtiquetas);

  // Arrays com .value (objetos de select)
  // IdsEquipes: deve enviar o identificador da equipe líder do usuário
  // (idEquipeLiderUsuario), persistido em filters.IdsEquipes — resolvido via hierarquia
  addField(body, "IdsOrigem", extractValues(filters.IdsOrigem));
  addField(body, "IdsCanalContato", extractValues(filters.IdsCanalContato));
  addField(
    body,
    "IdMotivoDesqualificacaoLead365",
    extractValues(filters.IdMotivoDesqualificacaoLead365)
  );

  const hierarchyFilters = resolveHierarchyFilters(filters);
  addField(body, "IdsCorretores", hierarchyFilters.IdsCorretores);
  addField(body, "IdUsuarioGerente", hierarchyFilters.IdUsuarioGerente);
  addField(
    body,
    "IdUsuarioSuperintendente",
    hierarchyFilters.IdUsuarioSuperintendente
  );
  addField(body, "IdsEquipes", hierarchyFilters.IdsEquipes);
  addField(
    body,
    "IdsRendaFamiliares",
    extractValues(filters.IdsRendaFamiliares)
  );
  addField(
    body,
    "IdsEmpreendimentos",
    extractValues(filters.IdsEmpreendimentos)
  );
  addField(
    body,
    "IdsBairrosEmpreendimentos",
    extractValues(filters.IdsBairrosEmpreendimentos)
  );
  addField(
    body,
    "IdSubEtapaFunil365",
    extractValues(filters.IdSubEtapaFunil365)
  );

  // Valores de intervalo
  addField(
    body,
    "InicioIntervaloValorImovel",
    filters.InicioIntervaloValorImovel
  );
  addField(body, "FimIntervaloValorImovel", filters.FimIntervaloValorImovel);

  // Filtro salvo
  addField(body, "idFiltro", filters.idFiltro);

  // Origem da requisição (ex.: indicadores da carteira)
  addField(body, "OrigemRequisicao", filters.OrigemRequisicao);

  // Tipo de visualização (1 = Lista, 2 = KanbanEtapa)
  addField(body, "TipoVisualizacao", filters.TipoVisualizacao);

  // Ordenação
  addField(body, "OrdenacaoLeads", filters.OrdenacaoLeads);
  addField(body, "OrdenacaoCrescente", filters.OrdenacaoCrescente);

  // Paginação
  addField(body, "PalavrasChave", filters.paginationParams?.PalavrasChave);
  addField(body, "PaginaAtual", filters.paginationParams?.PaginaAtual);
  addField(
    body,
    "TotalItensRetorno",
    filters.paginationParams?.TotalItensRetorno
  );

  return body;
}
